
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-to-integrate-with-bing-ads",
      function () {
        return require("private-next-pages/blog/how-to-integrate-with-bing-ads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-to-integrate-with-bing-ads"])
      });
    }
  